import { USER_TYPE } from "@/constants";
import { useUserContext } from "@/context/UserContext";

export type UsePermission = ReturnType<typeof usePermission>;

export default function usePermission() {
  const { user } = useUserContext();
  const permission = user?.Role?.$permissions;
  const companyPermissions = user?.Role?.$companyPermissions;
  const isAdmin = user?.Role?.name === USER_TYPE.SUPER_ADMIN;
  const isAdvertiser =
    user?.Role?.name === USER_TYPE.ADVERTISER ||
    user?.Role?.name === USER_TYPE.ADVERTISER_ADMIN ||
    Boolean(user?.asAdvertiser);
  const isAgencyAdmin = user?.Role?.name === USER_TYPE.AGENCY_ADMIN;
  const isAgencyUser = user?.Role?.name === USER_TYPE.AGENCY_USER;
  const isAdvertiserAdmin = user?.Role?.name === USER_TYPE.ADVERTISER_ADMIN;
  // `user` is null before login and again on logout (UserContext sets it back to
  // null), and CustomTable now calls this on every table in the app — including
  // whatever is still mounted during a logout render. Every other read here was
  // already optional-chained; these were the three that weren't.
  const companyId = user?.asAdvertiser ?? user?.companyId;

  return {
    permission,
    companyPermissions,
    isAdmin,
    isAdvertiser,
    isAgencyAdmin,
    isAgencyUser,
    isAdvertiserAdmin,
    companyId,
    parentCompanyId: user?.asAdvertiser
      ? user?.companyId
      : user?.parentCompanyId,
    isAsAdvertiser: Boolean(user?.asAdvertiser),
  };
}
